import Vue from 'vue'
import Vuex from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import modules from './modules/index.js'
import { getInfo } from '@/api/user.js'

Vue.use(Vuex)

const state = {
  isAssetLoading: false,
  isLogin: false,
  userInfo: null,
  roles: [],
  permissions: [],
  routes: [],
  isInitUserRoutes: false,
}
const getters = {
  isAssetLoading(state) {
    return state.isAssetLoading
  },
  isLogin(state) {
    return state.isLogin
  },
  userInfo(state) {
    return state.userInfo
  },
  tenantId(state) {
    if (!state.userInfo) {
      return 0
    }
    return state.userInfo['tenantId']
  },
  roles(state) {
    return state.roles
  },
  permissions(state) {
    return state.permissions
  },
  checkPermission(state) {
    return (permission) => {
      if (state.permissions.length === 0) {
        return false
      }
      if (state.permissions.length === 1 && state.permissions[0] === '*:*:*') {
        return true
      }
      return state.permissions.indexOf(permission) > -1
    }
  },
  routes(state) {
    return state.routes
  },
  isInitUserRoutes(state) {
    return state.isInitUserRoutes
  },
  isBelongTenant(state) {
    let isBelongTenant = false
    if (state.userInfo !== null) {
      isBelongTenant = ['Admin', 'Staff'].indexOf(state.userInfo.userType) > -1
    }
    return isBelongTenant
  },
  isBelongAgent(state, getters) {
    return getters.isAgent || getters.isAgentStaff || getters.isStore || getters.isStoreStaff
  },
  isAgent(state) {
    let isAgent = false
    if (state.userInfo !== null) {
      isAgent = ['Agent'].indexOf(state.userInfo.userType) > -1
    }
    return isAgent
  },
  isAgentStaff(state) {
    let isAgentStaff = false
    if (state.userInfo !== null) {
      isAgentStaff = ['AgentStaff'].indexOf(state.userInfo.userType) > -1
    }
    return isAgentStaff
  },
  isBelongStore(state, getters) {
    return getters.isStore || getters.isStoreStaff
  },
  isStore(state) {
    let isStore = false
    if (state.userInfo !== null) {
      isStore = ['Store'].indexOf(state.userInfo.userType) > -1
    }
    return isStore
  },
  isStoreStaff(state) {
    let isStoreStaff = false
    if (state.userInfo !== null) {
      isStoreStaff = ['StoreStaff'].indexOf(state.userInfo.userType) > -1
    }
    return isStoreStaff
  },
  isBelongSupplier(state) {
    let isBelongSupplier = false
    if (state.userInfo !== null) {
      isBelongSupplier = ['Supplier', 'SupplierStaff'].indexOf(state.userInfo.userType) > -1
    }
    return isBelongSupplier
  },
  getRegion(state) {
    if (!state.userInfo) {
      return ''
    }
    return state.userInfo['region']
  },
}
const mutations = {
  startLoadAsset(state) {
    state.isAssetLoading = true
  },
  endLoadAsset(state) {
    state.isAssetLoading = false
  },
  updateLoginState(state, isLogin) {
    state.isLogin = isLogin
  },
  updateUserInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  updatePermissions(state, permissions) {
    state.permissions = permissions
  },
  updateRoutes(state, routes) {
    state.routes = routes
    state.isInitUserRoutes = true
  },
  logout(state) {
    state.isLogin = false
    state.userInfo = null
    state.permissions = []
    state.routes = []
    state.isInitUserRoutes = false
  },
}
const actions = {
  initUser({ commit }, { success, fail }) {
    commit('startLoadAsset')
    getInfo({
      success: ({ user, permissions = [], routes = [] }) => {
        commit('updateLoginState', true)
        commit('updateUserInfo', user)
        commit('updatePermissions', permissions)
        // 插入路由（抽取根路由的所有子路由）
        let menuRoutes = []
        let childrenRoutes = []
        for (const route of routes) {
          if (route['path'] === '/') {
            let children = route['children'] || [];
            const isCatalog = route['alwaysShow'] === true && route['redirect'] === 'noRedirect'
            if (isCatalog) {
              childrenRoutes = childrenRoutes.concat(children)
              children = [{
                children: children,
                component: '',
                hidden: route['hidden'],
                meta: route['meta'],
                name: uuidv4().replaceAll(`-`, ''),
                path: '#'
              }]
            } else {
              childrenRoutes = childrenRoutes.concat(children)
            }
            if (!route['hidden']) {
              menuRoutes = menuRoutes.concat(children)
            }
          }
        }
        commit('updateRoutes', menuRoutes)
        success(childrenRoutes)
      },
      fail,
      complete: () => {
        commit('endLoadAsset')
      },
    })
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules,
})
